import React, { useEffect } from "react";
import Checkmark from "../../assets/images/checkmark.png";
import QuizManiaSucces from "../../assets/images/quiz-mania-succes.png";
import LogoDogSit from "../../assets/images/catbook/cat-heart-p2.png";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import TopLogoCat from "../../components/layout/TopLogoCat";
import { SearchId } from "../../services/SearchId";
import { setQuestionnaire } from "../../features/QuestionnaireSlice";
import { setQuizMania } from "../../features/QuizManiaSlice";
import helper from "../../functions/helper";
import SuccessStyle from "../../assets/images/success-style.png";
import PopupQuestionnaireSuccessCat from "../../components/popup/PopupQuestionnaireSuccessCat";
import PrimaryGreenButton from "../../components/button/PrimaryGreenButton";

export default function QuestionnaireSuccessCat() {
  const store = useSelector((state) => state.questionnaire);
  const [openCancelPopup, setOpenCancelPopup] = React.useState(true);
  const [memberId, setMemberId] = React.useState(true);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const year = searchParams.get("year");
  const quarter = searchParams.get("quarter");
  const quizId = searchParams.get("quiz");

  const isQuarter = searchParams.get("quarter") ? true : false;

  const [isQuizMania, setIsQuizMania] = React.useState(false);
  const [lineId, setLineId] = React.useState(null);

  // const { liff } = useLiff();
  // const lineId = liff.getDecodedIDToken().sub;

  const dispatch = useDispatch();
  // const qRegisterAns = searchParams.get('registerAns')
  // const registerAns = JSON.parse(qRegisterAns)

  const registerAnsStr = window.localStorage.getItem("p");
  let registerAns = {};
  if (registerAnsStr) {
    // registerAns = JSON.parse(atob(registerAnsStr))
    registerAns = helper.decodeJWT(registerAnsStr);
  }

  const getLineLiff = async () => {
    const path = window.location.pathname;
    const liffId = helper.getLiffIdByENV(path, "dev");
    console.log(path)

    await liff.init({ liffId: liffId });
    if (!liff.isLoggedIn()) {
      const destinationUrl = window.location.href;
      liff.login({ redirectUri: destinationUrl });
    }
    console.log(liffId)
    const _lineId = liff.getDecodedIDToken()?.sub
    window.localStorage.removeItem("sub");
    window.localStorage.setItem("sub", _lineId);
    console.log(_lineId)
    setLineId(_lineId);
    getSearchId(_lineId);
  };

  const isMember = memberId ?? false;
  const isShowPoint = store["points"] !== 0;

  useEffect(() => {
    getLineLiff();
    //
    const { memberId, points, payload } = registerAns;
    if (isQuarter) {
      setIsQuizMania(true);
      fnSetQuizData("memberId", memberId ?? null);
      fnSetQuizData("points", points);
      fnSetQuizData("payload", payload);
    } else {
      fnSetQuestionnaireData("memberId", memberId ?? null);
      fnSetQuestionnaireData("points", points);
      fnSetQuestionnaireData("payload", payload);
    }
  }, []);

  async function getSearchId(_lineId) {
    return await SearchId({
      params: { lineId: _lineId , species: 2 },
    })
      .then(async (response) => {
        if (!response.data.body.memberId) {
          setMemberId(null);
        } else {
          setMemberId(response.data.body.memberId);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function fnSetQuestionnaireData(name, value) {
    const tmpObj = {};
    tmpObj[name] = value;
    dispatch(setQuestionnaire(tmpObj));
  }

  function fnSetQuizData(name, value) {
    const tmpObj = {};
    tmpObj[name] = value;
    dispatch(setQuizMania(tmpObj));
  }

  return (
    <>
      <PopupQuestionnaireSuccessCat
        point={store["points"]}
        actionFunction={() => {
          setOpenCancelPopup(false);
        }}
        open={isShowPoint && isMember && openCancelPopup}
        onClose={() => {
          setOpenCancelPopup(false);
        }}
      />
      <TopLogoCat />
      {/* {JSON.stringify(store)} */}
      <div
        style={{
          minHeight: "calc(100vh - 60px)",
          padding: "20px",
          background: "linear-gradient(129.17deg, #213468 22.83%, #213468 36.49%, #1D4164 41.4%, #15645A 50.69%, #079D4A 63.25%, #07A14A 63.8%, #07A14A 77.45%)",

        }}
      >
        <img
          src={SuccessStyle}
          alt="logo"
          style={{ width: "70%", float: "right" }}
          className="mt-[-20px] mr-[-20px]"
        />
        <div className="mt-[40px] w-full" style={{
          position: "fixed",
          left: "50%",
          transform: "translate(-50%, 0)"
        }}>
          <img
            className="mx-auto mt-[18px]"
            src={Checkmark}
            alt="logo"
            style={{ maxWidth: "52px" }}
          />

          <div className="text-white text-center text-[36px] mt-[10px] leading-[100%]">
            ตอบคำถามเรียบร้อย
          </div>
          <div className="text-white text-center text-[24px] leading-[100%]">
            ขอบคุณที่ร่วมสนุก
          </div>
          {isQuizMania ? (
            <>
              <img
                className="mx-auto mt-[24px] w-full max-w-[236px]"
                src={QuizManiaSucces}
                alt="logo"
              />
              <p className="text-white text-center text-[20px] leading-[120%] mt-[24px]">ติดตามเฉลยคำตอบของ Quiz mania ได้ที่<br />โพสต์ Line Voom ของ Spectra For Dog ในช่วงต้นเดือน</p>
            </>
          ) : (
            <img
              className="mx-auto"
              src={LogoDogSit}
              alt="logo"
              style={{ width: "50%" }}
            />
          )}
          {isQuizMania ? (
            <div className="bQuizManiaSucccessMain">
              <div className="bQuizManiaSucccess">
                {isMember ? (
                  <>
                    <button
                      className="btn _outline"
                      onClick={() =>
                        navigate(
                          `/quiz-mania-rank-cat?quiz=${quizId}&year=${year}&quarter=${quarter}`
                        )
                      }
                    >
                      เช็คอันดับคะแนนของคุณ
                    </button>
                    <button
                      className="btn _outline transparent"
                      onClick={() => navigate("/redeem-gift-member-cat")}
                    >
                      ไปยัง Privilege
                    </button>
                  </>
                ) : (
                  <button
                    className="btn _outline"
                    onClick={() => {
                      window.localStorage.removeItem("p");
                      window.location.replace("/register-cat");
                    }}
                  >
                    ลงทะเบียน One And Done
                  </button>
                )}
              </div>
            </div>
          ) : (
            <div className="text-center mt-[50px]">
              <div className="my-4">
                {isMember ? (
                  <PrimaryGreenButton
                    variant="contained"
                    className="w-[70%]"
                    onClick={() => {
                      window.localStorage.removeItem("p");
                      // navigate("/catbook");
                      window.location.replace("/catbook");
                    }}
                  >
                    กลับไปที่สมุดพกสัตว์เลี้ยง
                  </PrimaryGreenButton>
                ) : (
                  <PrimaryGreenButton
                    variant="contained"
                    className="w-[70%]"
                    onClick={() => {
                      window.localStorage.removeItem("p");
                      navigate("/register-cat");
                    }}
                  >
                    ลงทะเบียน One And Done
                  </PrimaryGreenButton>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
